module.exports = __webpack_public_path__ + "static/media/web logos_DigiL.9a1d2e3d.jpg";